import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade, Autoplay, Keyboard } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';

// Function to initialize the slider
export default function initSliderHome(sliderElement, props) {
    if (!sliderElement) {
        console.error('Slider element not found.');
        return;
    }

    const paginationEl = sliderElement.querySelector('.Pagination--hero');
    if (!paginationEl) {
        console.error('Pagination element not found inside slider.');
        return;
    }

    console.log('Initializing Swiper with props:', props);

    const slider = new Swiper(sliderElement, {
        modules: [Navigation, Pagination, EffectFade, Autoplay, Keyboard],
        effect: 'fade',
        loop: true,
        keyboard: {
            enabled: true,
        },
        pagination: {
            el: paginationEl, // Ensure this matches the actual element
            clickable: true,
            renderBullet: function (index, className) {
                return `<div class="item-Pagination ${className}"></div>`;
            },
        },
        autoplay: props.autoplay || {
            delay: 5000,
            disableOnInteraction: false,
        },
        speed: props.speed || 800,
    });
}